const MAX_CATEGORY_PATH_DEPTH = 2;

export const slugifyCategory = (value) =>
  String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const normalizeCategoryPath = (value) =>
  (Array.isArray(value) ? value : [])
    .map((item) => String(item || "").trim())
    .filter(Boolean)
    .slice(0, MAX_CATEGORY_PATH_DEPTH);

export const buildCategoryHref = ({ categoryId, name, categoryPath = [] }) => {
  const slug = slugifyCategory(name || normalizeCategoryPath(categoryPath).slice(-1)[0] || "category");
  const id = String(categoryId || "").trim();
  const path = normalizeCategoryPath(categoryPath);
  const query = new URLSearchParams();
  if (id) query.set("cid", id);
  if (path.length) query.set("path", JSON.stringify(path));
  const qs = query.toString();
  return `/category/${slug}${qs ? `?${qs}` : ""}`;
};

export const parseCategoryPathParam = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return [];
  try {
    return normalizeCategoryPath(JSON.parse(raw));
  } catch {
    return normalizeCategoryPath(raw.split(/[>|/]/));
  }
};
